@if (isLoading() && !showCreateOnly()) {
  <cor-skeleton [type]="SKELETON_TYPES.DETAILS" />
} @else if (isNotFound()) {
  @if (showCreateOnly()) {
    <p-message
      severity="warn"
      icon="pi pi-shield"
      class="tw:mb-3">
      <div class="tw:flex tw:items-center">
        <span>No risk assessment has been created for this pipeline version yet.</span>
        <p-button
          test-id="pipeline-risk-assessment-click-to-create"
          [buttonProps]="{ autofocus: false }"
          variant="text"
          [loading]="create.isLoading()"
          [disabled]="create.isLoading()"
          label="Click to create"
          (click)="create.onShow()" />
      </div>
    </p-message>
  } @else {
    <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:h-full tw:p-6">
      <cor-no-data
        [showIcon]="true"
        noDataMessage="No risk assessment is linked to this pipeline yet.">
        <p-button
          test-id="pipeline-risk-assessment-create-new-risk-assessment"
          [buttonProps]="{ autofocus: false }"
          class="tw:mt-2"
          icon="pi pi-plus"
          variant="outlined"
          [loading]="create.isLoading()"
          [disabled]="create.isLoading()"
          label="Create new risk assessment"
          (click)="create.onShow()" />
      </cor-no-data>
    </div>
  }
} @else if (this.item() && !showCreateOnly()) {
  <div class="tw:flex tw:items-center tw:mb-3">
    <div class="tw:flex-1 tw:truncate tw:text-xl tw:font-semibold">Risk Assessment</div>
    <a
      test-id="pipeline-risk-assessment-configure"
      pButton
      [buttonProps]="{ autofocus: false }"
      [routerLink]="configurationLink()"
      severity="secondary"
      size="small"
      icon="pi pi-external-link"
      iconPos="right"
      label="Configure"></a>
  </div>
  <cor-risk-assessment-details />
}

<cor-dialog-box
  [(visible)]="create.isVisible"
  title="Create new risk assessment"
  (onHide)="create.onHide()">
  @if (create.isVisible()) {
    <cor-input-container label="Name">
      <input
        test-id="pipeline-risk-assessment-name"
        pInputText
        type="text"
        [fluid]="true"
        placeholder="Please provide a name"
        [formControl]="create.form.controls.name" />
    </cor-input-container>

    <div class="tw:flex tw:flex-col tw:gap-3">
      <div class="tw:text-base tw:font-medium tw:text-color">How would you like to start?</div>

      <label
        class="tw:flex tw:cursor-pointer tw:items-start tw:gap-3 tw:rounded-xl tw:border tw:border-surface tw:p-3"
        [ngClass]="{
          'tw:bg-highlight tw:border-primary!': !create.copy(),
        }"
        (click)="create.copy.set(false)">
        <p-radiobutton
          test-id="pipeline-risk-assessment-create-mode"
          name="createMode"
          [value]="false"
          class="tw:my-1"
          [(ngModel)]="create.copy"
          [ngModelOptions]="{ standalone: true }" />
        <div class="tw:flex tw:flex-col tw:gap-1">
          <div class="tw:text-base tw:font-medium tw:text-color">Start blank</div>
          <div class="tw:text-sm tw:text-muted-color">
            Configure categories and document all findings from scratch.
          </div>
        </div>
      </label>

      <label
        class="tw:flex tw:cursor-pointer tw:items-start tw:gap-3 tw:rounded-xl tw:border tw:border-surface tw:p-3"
        [ngClass]="{
          'tw:bg-highlight tw:border-primary!': create.copy(),
        }"
        (click)="create.versionList().length > 0 && create.copy.set(true)">
        <p-radiobutton
          test-id="pipeline-risk-assessment-create-mode-2"
          name="createMode"
          [value]="true"
          [disabled]="create.versionList().length === 0"
          class="tw:my-1"
          [(ngModel)]="create.copy"
          [ngModelOptions]="{ standalone: true }" />
        <div class="tw:flex tw:flex-1 tw:flex-col tw:gap-1">
          <div class="tw:flex tw:items-center tw:gap-2 tw:text-base tw:font-medium tw:text-color">
            Copy from previous version
            @if (create.versionList().length > 0) {
              <p-select
                test-id="pipeline-risk-assessment-select-version"
                class="tw:border-none tw:shadow-none tw:p-0"
                style="
                  --p-select-background: var(--p-tag-success-background);
                  --p-select-dropdown-color: var(--p-tag-success-color);
                  --p-select-dropdown-width: 1.8rem;
                  --p-select-sm-padding-y: 0;
                  --p-select-sm-padding-x: 0;
                "
                [options]="create.versionList()"
                [(ngModel)]="create.sourcePipelineVersionId"
                [ngModelOptions]="{ standalone: true }"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                placeholder="Select version"
                size="small">
                <ng-template
                  pTemplate="selectedItem"
                  let-selectedVersion>
                  <p-tag
                    severity="success"
                    icon="pi pi-history"
                    [value]="selectedVersion.label" />
                </ng-template>
              </p-select>
            }
          </div>
          <div class="tw:text-sm tw:text-muted-color">
            Carry findings forward from the last assessment, then review.
          </div>
          @if (create.versionList().length === 0) {
            <div class="tw:text-sm tw:text-muted-color">
              No previous versions are available to copy from.
            </div>
          }
        </div>
      </label>
    </div>

    <ng-template #footer>
      <p-button
        test-id="pipeline-risk-assessment-cancel"
        [buttonProps]="{ autofocus: false }"
        (click)="create.onHide()"
        severity="secondary"
        label="Cancel" />
      <p-button
        test-id="pipeline-risk-assessment-create"
        [buttonProps]="{ autofocus: false }"
        [loading]="create.isSaving()"
        [disabled]="create.isSaving()"
        (click)="create.onSave()"
        label="Create" />
    </ng-template>
  }
</cor-dialog-box>
